import { TransformNode, } from '@babylonjs/core';
import { not } from 'fp-ts/lib/Predicate';
export var Type;
(function (Type) {
    /** Every rendered particle */
    Type["PARTICLE_TRANSFORM"] = "particleTransform";
    /** the Delta Origin modifies the particle transform to give it a specific position. This allows unusual models to have set and standard origin positions */
    Type["PARTICLE_DELTA_ORIGIN_TRANSFORM"] = "particleDeltaOriginTransform";
    /**
     * when rendering a single furniture, this transform is the root
     */
    Type["ROOT_FURNITURE_TRANSFORM"] = "rootFurnitureTransform";
    /**
     * when rendering a single particle, this transform is the root
     */
    Type["SINGLE_PARTICLE_TRANSFORM"] = "rootParticleTransform";
    Type["FLOOR_TRANSFORM"] = "floorTransform";
    Type["SINGLE_WALL_TRANSFORM"] = "singleWallTransform";
    Type["REFERENCE_WALL_TRANSFORM"] = "refWallTransform";
})(Type || (Type = {}));
export const create = (type) => new TransformNode(type);
export const createForParticle = () => create(Type.PARTICLE_TRANSFORM);
export const createForParticleDeltaOrigin = () => create(Type.PARTICLE_DELTA_ORIGIN_TRANSFORM);
export const createForRootFurniture = () => create(Type.ROOT_FURNITURE_TRANSFORM);
export const createForRootParticle = () => create(Type.SINGLE_PARTICLE_TRANSFORM);
export const createForFloor = () => create(Type.FLOOR_TRANSFORM);
export const createForWall = () => create(Type.SINGLE_WALL_TRANSFORM);
export const createForWallRef = () => create(Type.REFERENCE_WALL_TRANSFORM);
export const isType = (type) => (t) => t.name === type;
export const find = (type) => (transforms) => transforms.find(t => t.name === type);
export const findParticle = find(Type.PARTICLE_TRANSFORM);
export const findParticleDeltaOrigin = find(Type.PARTICLE_DELTA_ORIGIN_TRANSFORM);
export const findRootFurniture = find(Type.ROOT_FURNITURE_TRANSFORM);
export const findRootParticle = find(Type.SINGLE_PARTICLE_TRANSFORM);
export const findFloor = find(Type.FLOOR_TRANSFORM);
export const findWallRef = find(Type.REFERENCE_WALL_TRANSFORM);
export const findRoot = (transforms) => {
    const furniture = findRootFurniture(transforms);
    const particle = findRootParticle(transforms);
    return furniture ?? particle;
};
export const findAll = (type) => (transforms) => transforms.filter(t => t.name === type);
export const findAllParticle = findAll(Type.PARTICLE_TRANSFORM);
export const findAllParticleDeltaOrigin = findAll(Type.PARTICLE_DELTA_ORIGIN_TRANSFORM);
export const findAllRootFurniture = findAll(Type.ROOT_FURNITURE_TRANSFORM);
export const findAllRootParticle = findAll(Type.SINGLE_PARTICLE_TRANSFORM);
export const findAllWall = findAll(Type.SINGLE_WALL_TRANSFORM);
export const hasGeometryLoaded = (transform) => transform.getChildMeshes().some(mesh => mesh.hasBoundingInfo);
/** Dispose transforms belonging to types other than the one provided */
export const disposeOtherTypes = (types) => (transforms) => transforms.filter(not(t => types.map(isType).some(f => f(t)))).forEach(t => t.dispose(false));
export const disposeType = (type) => (transforms) => transforms.filter(isType(type)).forEach(t => t.dispose(false));
